import { message, notification } from 'antd'
import { generateMessageError } from 'modules/core/utils'
import i18n from 'i18next'
import moment from 'moment'

export const disabledDate = (date, cutDates, disabledMonths) => {
  const pickerDate = moment(date._d).utc().format('YYYY-M')

  if (cutDates.length === 0) {
    return true
  }

  return !cutDates.includes(pickerDate) || disabledMonths.includes(pickerDate)
}

export const forecastCreate = ({ form, setIsLoading, createForecast, onRefetch, onClose }) => {
  form.validateFields().then((values) => {
    setIsLoading(true)
    createForecast(values)
      .then(() =>
        onRefetch().then(() => {
          message.success(i18n.t('FEEDBACK_CREATE_SUCCESS'), 8)
          onClose()
        }),
      )
      .catch((error) => {
        notification.error({
          message: i18n.t('FEEDBACK_DEFAULT_ERROR'),
          description: generateMessageError(error, 'FEEDBACK_CREATION_FAIL'),
          duration: 0,
        })
        onClose()
      })
  })
}
